import React from "react";
import { NavLink } from "react-router-dom";
import { navLinks } from "./navLinks";

/**
 * DesktopNavigation — centered nav link cluster used inside Header on
 * viewports >= 992px.
 */
export default function DesktopNavigation() {
  return (
    <nav className="desktop-nav desktop-only" aria-label="Primary">
      <ul>
        {navLinks.map((link) => (
          <li key={link.to}>
            <NavLink to={link.to} end={link.to === "/"} className={({ isActive }) => (isActive ? "is-active" : "")}>
              {link.label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
